import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

import { SharedLanguageService } from '@language';
import { DialogStyle } from '../../elements/components/dialog/entities/dialog.entity';
import { ShBooleanDialogComponent, ShTextInputDialogComponent } from '../dynamic-dialog.module';
import { DialogRef } from '../entities/dialog-ref.class';
import { ShDynamicDialogService } from '../services/dynamic-dialog.service';

export interface ConfirmationDialogConfig {
    title: string;
    errorMessage?: string;
    warningMessage?: string;
    infoMessage?: string;
    message?: string;
    yes?: string;
    no?: string;
}
export interface TextInputDialogConfig {
    title: string;
    errorMessage?: string;
    warningMessage?: string;
    infoMessage?: string;
    message?: string;
    inputLabel: string;
    confirm: string;
    no: string;
}

@Injectable({ providedIn: 'root' })
export class DialogHelperBase {
    constructor(
        public dialogService: ShDynamicDialogService,
        public translateService: SharedLanguageService
    ) {}

    public confirm(config: ConfirmationDialogConfig, style: DialogStyle = DialogStyle.Normal): Observable<boolean> {
        const ref: DialogRef<boolean> = this.dialogService.open(ShBooleanDialogComponent, {
            title: config.title,
            options: {
                style
            },
            data: {
                message: config.message,
                ...(!!config.infoMessage && { infoMessage: config.infoMessage }),
                ...(!!config.warningMessage && { warningMessage: config.warningMessage }),
                ...(!!config.errorMessage && { errorMessage: config.errorMessage }),
                yes: config.yes,
                no: config.no
            }
        });

        const confirm$: Observable<boolean> = ref.afterClosed$;
        return confirm$;
    }

    public input(config: TextInputDialogConfig, style: DialogStyle = DialogStyle.Normal): Observable<string> {
        const ref: DialogRef<string> = this.dialogService.open(ShTextInputDialogComponent, {
            title: config.title,
            options: {
                style
            },
            data: {
                ...config
            }
        });

        const input$: Observable<string> = ref.afterClosed$.pipe(filter(val => val !== null));
        return input$;
    }
}
